import { render } from "./VTextArea.vue?vue&type=template&id=ce3b137e&ts=true"
import script from "./VTextArea.vue?vue&type=script&lang=ts"
export * from "./VTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__